import {
    Button,
    Dialog,
    FormControl,
    FormControlLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
} from '@material-ui/core';
import React from 'react';
import { useState } from 'react';
import en from '../../../../lang/en-us';

const { dbCommercial, common } = en;

export default function MfCart(props: any) {
    const [paymentMode, setPaymentMode] = useState<string | null>(null);
    const [show, setShow] = useState<boolean>(false);
    const [value, setValue] = React.useState('otm');
    const [payment, setPayment] = useState<boolean>(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
    };
    return (
        <div className="curved-bg mf-investment mf-cart">
            <h2 className="heading">
                <a onClick={() => props.history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dbCommercial.ctLinks.newPurchase} - Lumpsum
            </h2>
            <div className="curved-bg-content">
                <div className="mf-investment-left">
                    <h3>
                        <img src="/images/add-cart-icon.svg" alt="icon" />
                        {dbCommercial.exploreMfs.mfCart.heading}(2)
                    </h3>
                    <div className="cart-investment-details">
                        <h4>Lumpsum</h4>
                        <div className="cart-investment-details-info">
                            <div className="cart-investment-details-txt">
                                <h3>
                                    <img src="/images/nippon-fav.png" alt="icon" />
                                    Nippon India Nifty Smallcap 250 Index Fund Dir Gr
                                </h3>
                                <div className="cart-investment-details-bottom">
                                    <p>
                                        SIP Date <span>09</span> of every month
                                    </p>
                                    <p>
                                        Amount <span>₹ 5,000</span>
                                    </p>
                                </div>
                            </div>
                            <div className="icons">
                                <a>
                                    <img src="/images/edit-icon-filled.svg" alt="icon" />
                                </a>
                                <a>
                                    <img src="/images/delete-icon-filled.svg" alt="icon" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="cart-investment-details">
                        <h4>SIP</h4>
                        <div className="cart-investment-details-info">
                            <div className="cart-investment-details-txt">
                                <h3>
                                    <img src="/images/nippon-fav.png" alt="icon" />
                                    Nippon India Nifty Smallcap 250 Index Fund Dir Gr
                                </h3>
                                <div className="cart-investment-details-bottom">
                                    <p>
                                        SIP Date <span>09</span> of every month
                                    </p>
                                    <p>
                                        Amount <span>₹ 5,000</span>
                                    </p>
                                </div>
                            </div>
                            <div className="icons">
                                <a>
                                    <img src="/images/edit-icon-filled.svg" alt="icon" />
                                </a>
                                <a>
                                    <img src="/images/delete-icon-filled.svg" alt="icon" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="add-more-funds">
                        <Button className="customBtn">
                            +{dbCommercial.exploreMfs.mfCart.addMoreFunds}
                        </Button>
                    </div>
                </div>
                <div className="mf-investment-right">
                    {!payment ? (
                        <div className="cart-proceed">
                            <div className="heading">
                                <h4>
                                    {dbCommercial.exploreMfs.mfCart.cartDetails}{' '}
                                    <img src="/images/rupee-coin.png" alt="icon" />
                                </h4>
                            </div>
                            <div className="schemes-added">
                                <h5>2{dbCommercial.exploreMfs.mfCart.schemesAdded} </h5>
                                <div className="schemes-added-info">
                                    <p>{dbCommercial.exploreMfs.mfCart.lumpsum}</p>
                                    <h6>1 {dbCommercial.exploreMfs.mfCart.scheme}</h6>
                                </div>
                                <div className="schemes-added-info">
                                    <p>{dbCommercial.exploreMfs.mfCart.sip}</p>
                                    <h6>1 {dbCommercial.exploreMfs.mfCart.scheme}</h6>
                                </div>
                                <div className="schemes-added-info total-scheme">
                                    <p>{dbCommercial.exploreMfs.mfCart.totalAmount}</p>
                                    <h6>₹ 10,000</h6>
                                </div>
                            </div>
                            <Button className="customBtn" onClick={() => setPayment(!payment)}>
                                {dbCommercial.exploreMfs.mfCart.proceedToPay}
                            </Button>
                        </div>
                    ) : (
                        <div className="cart-payvia">
                            <h3>
                                <a onClick={() => setPayment(!payment)}>
                                    <img src="/images/left-arrow-black.svg" alt="icon" />
                                </a>
                                {dbCommercial.exploreMfs.mfCart.amountPayable} <span>₹ 10,000</span>
                            </h3>
                            <FormControl component="fieldset" className="db-radio">
                                <RadioGroup
                                    aria-labelledby="pay-via"
                                    name="pay-via"
                                    value={value}
                                    onChange={handleChange}
                                >
                                    <div className="cart-payvia-radio">
                                        <FormControlLabel
                                            value="otm"
                                            control={<Radio />}
                                            label={
                                                <>
                                                    <img src="/images/net-banking.png" alt="icon" />
                                                    {dbCommercial.exploreMfs.mfPayment.otm}
                                                </>
                                            }
                                        />
                                        <div className="reg-mode">
                                            <p>
                                                {
                                                    dbCommercial.exploreMfs.mfPayment
                                                        .modeOfRegistration
                                                }
                                            </p>
                                            <div className="reg-mode-select">
                                                <FormControl
                                                    variant="filled"
                                                    className="mf-investment-select"
                                                >
                                                    <Select
                                                        labelId="reg-mode-label"
                                                        id="reg-mode-sortby"
                                                        value="1"
                                                    >
                                                        <MenuItem value={1}>KOTM</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                <a onClick={() => setShow(!show)}>
                                                    + {dbCommercial.exploreMfs.mfPayment.addNew}
                                                </a>
                                            </div>
                                            <Button
                                                className="customBtn "
                                                onClick={() =>
                                                    props.history.push(
                                                        '/portal/commercial/mf-success',
                                                    )
                                                }
                                            >
                                                {dbCommercial.exploreMfs.mfPayment.payVia}OTM
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="cart-payvia-radio">
                                        <FormControlLabel
                                            value="upi"
                                            control={<Radio />}
                                            label={
                                                <>
                                                    <img src="/images/upi.png" alt="icon" />
                                                    {dbCommercial.exploreMfs.mfPayment.upi}
                                                </>
                                            }
                                        />
                                    </div>
                                    <div className="cart-payvia-radio">
                                        <FormControlLabel
                                            value="net-banking"
                                            control={<Radio />}
                                            label={
                                                <>
                                                    <img src="/images/net-banking.png" alt="icon" />
                                                    {dbCommercial.exploreMfs.mfPayment.netBanking}
                                                </>
                                            }
                                        />
                                    </div>
                                </RadioGroup>
                            </FormControl>
                        </div>
                    )}
                </div>
            </div>
            <Dialog
                maxWidth={'sm'}
                open={show}
                aria-labelledby="newbank-mandate-modal"
                onClose={() => setShow(false)}
            >
                <div className="note-modals newbank-mandate-modal">
                    <h3>{dbCommercial.exploreMfs.mfPayment.modal.heading}</h3>
                    <a onClick={() => setShow(!show)} className="close">
                        <img src="/images/close-black.svg" alt="icon" />
                    </a>
                    <div className="note-modals-content">
                        <div className="mandate-amount">
                            <TextField
                                label={dbCommercial.exploreMfs.mfPayment.modal.mandateAmount}
                                id="enter-arn"
                                variant="outlined"
                            />
                            <p>
                                <img src="/images/exclaim.svg" alt="icon" />
                                Valid From (Today)
                                <span>30-12-2021</span>
                            </p>
                        </div>
                        <FormControl variant="filled" className="bank-account-select">
                            <Select labelId="reg-mode-label" id="reg-mode-sortby" value="0">
                                <MenuItem value={0}>
                                    {dbCommercial.exploreMfs.mfPayment.modal.bankAccount}
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            label={dbCommercial.exploreMfs.mfPayment.modal.ifsc}
                            id="enter-arn"
                            variant="outlined"
                        />
                        <div className="note-modals-btns">
                            <Button className="customBtn" onClick={() => setShow(!show)}>
                                {dbCommercial.exploreMfs.mfPayment.modal.submit}
                            </Button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
